import { render, staticRenderFns } from "./sales.index.vue?vue&type=template&id=25f14e20&"
import script from "./sales.index.vue?vue&type=script&lang=js&"
export * from "./sales.index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports